
import { defineComponent } from "vue";
import Results from "../../components/results/Results.vue";
import { useBooks } from "../../utils/composable/useBooks";
export default defineComponent({
  components: {
    Results,
  },
  setup() {
    const { getUserBooks, loading, results } = useBooks();

    getUserBooks();

    return { loading, results };
  },
});
